/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Overview_Cancel_DowngradeInputs */



/**
* | output |
* | --- |
* | "Cancel downgrade" |
*
* @param {Sub_Overview_Cancel_DowngradeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_cancel_downgrade = /** @type {((inputs?: Sub_Overview_Cancel_DowngradeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Cancel_DowngradeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Downgrade abbrechen")
	return /** @type {LocalizedString} */ ("Cancel downgrade")
});